module.exports = __webpack_public_path__ + "img/ph-bg-mobile.1381f1d8.webp";